import { AdvanceSearchForm } from './AdvanceSearchForm'
import { withAdvanceSearchForm } from './withAdvanceSearchForm'

const ConnectedAdvanceSearchForm = withAdvanceSearchForm(AdvanceSearchForm)

export { ConnectedAdvanceSearchForm as AdvanceSearchForm }
